import * as React from "react";
import { forwardRef } from "react";
const SvgLine = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 8" ref={ref} {...props}><path d="M1 6.937 2.737 4.91l3.764 1.158 2.316-4.343 2.027 2.896L14.607.567" /></svg>;
const ForwardRef = forwardRef(SvgLine);
export default ForwardRef;